import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0d1f35]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="py-14 grid grid-cols-1 md:grid-cols-[1.5fr_1fr_1fr_1fr] gap-10 border-b border-white/8">
          <div>
            <div className="flex items-center gap-3 mb-5 cursor-pointer" onClick={() => navigate('/')} title="SugarHathi home">
              <div className="w-9 h-9 rounded-lg overflow-hidden bg-white/10 flex-shrink-0">
                <img src="/assets/images/ChatGPT_Image_Dec_1_2025_08_15_51_PM-1764613791088.png" alt="SugarHathi logo" className="w-full h-full object-contain" />
              </div>
              <span className="text-base font-black text-white">SugarHathi</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs mb-6">India&#39;s private B2B sugar procurement platform. Connecting verified mills, transporters, and buyers with verified factory-gate loading.</p>
            <div className="flex items-center gap-2 text-xs text-slate-500">
              <Icon name="MapPin" size={13} />
              <span>India · Serving all major sugar-producing states</span>
            </div>
          </div>
          <div>
            <p className="text-xs font-bold text-slate-500 uppercase tracking-widest mb-5">Platform</p>
            <ul className="space-y-3">
              <li><button onClick={() => navigate('/sugar-marketplace-dashboard')} className="text-sm text-slate-400 hover:text-white transition-colors">Sugar Marketplace</button></li>
              <li><button onClick={() => navigate('/truck-marketplace')} className="text-sm text-slate-400 hover:text-white transition-colors">Truck Marketplace</button></li>
              <li><button onClick={() => navigate('/mandi')} className="text-sm text-slate-400 hover:text-white transition-colors">Live Prices</button></li>
              <li><button onClick={() => navigate('/market-intelligence')} className="text-sm text-slate-400 hover:text-white transition-colors">Market Intelligence</button></li>
              <li><button onClick={() => navigate('/track')} className="text-sm text-slate-400 hover:text-white transition-colors">Track Shipment</button></li>
              <li><button onClick={() => navigate('/news-and-market-prices')} className="text-sm text-slate-400 hover:text-white transition-colors">Market Prices</button></li>
              <li><button onClick={() => navigate('/login-authentication')} className="text-sm text-slate-400 hover:text-white transition-colors">Sign In</button></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold text-slate-500 uppercase tracking-widest mb-5">Legal</p>
            <ul className="space-y-3">
              <li><a href="/privacy-policy" className="text-sm text-slate-400 hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="/terms" className="text-sm text-slate-400 hover:text-white transition-colors">Terms &amp; Conditions</a></li>
              <li><a href="/refund" className="text-sm text-slate-400 hover:text-white transition-colors">Refund Policy</a></li>
              <li><a href="/pricing" className="text-sm text-slate-400 hover:text-white transition-colors">Pricing</a></li>
              <li><a href="/about" className="text-sm text-slate-400 hover:text-white transition-colors">About Us</a></li>
              <li><a href="/contact" className="text-sm text-slate-400 hover:text-white transition-colors">Contact Us</a></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold text-slate-500 uppercase tracking-widest mb-5">Tools</p>
            <ul className="space-y-3">
              <li><a href="/do-verify" className="text-sm font-medium hover:opacity-80 transition-opacity" style={{ color: '#d97706' }}>Verify SugarHathi Documents</a></li>
            </ul>
          </div>
        </div>
        <div className="py-5 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-slate-500 text-xs">&#169; {currentYear} Villgrains FarmTech Private Limited. All rights reserved.</p>
          <div className="flex items-center gap-5 text-xs text-slate-500">
            <a href="/privacy-policy" className="hover:text-slate-300 transition-colors">Privacy</a>
            <a href="/terms" className="hover:text-slate-300 transition-colors">Terms</a>
            <a href="/contact" className="hover:text-slate-300 transition-colors">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

